import React from "react"

const Rating = ({ value }) => {
  return (
    <div className="c-Rating">
      <i className={value >= 1 ? "fa fa-star" : "fa fa-star-o"}></i>
      <i className={value >= 2 ? "fa fa-star" : "fa fa-star-o"}></i>
      <i className={value >= 3 ? "fa fa-star" : "fa fa-star-o"}></i>
      <i className={value >= 4 ? "fa fa-star" : "fa fa-star-o"}></i>
      <i className={value >= 5 ? "fa fa-star" : "fa fa-star-o"}></i>
    </div>
  )
}

export default Rating


// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ReviewsListWidget/Rating.jsx